module.exports = __webpack_public_path__ + "img/A58A1808_min.b9acf2bc.jpg";